import { BrowserRouter, Routes, Route } from "react-router-dom";
import KennyFish from "./privacy/KennyFish.jsx";
import DeleteAccount from "./delete/KennyFish.jsx";
import Rayhancar from "./privacy/Rayhancar.jsx";
import Triphop from "./privacy/Triphop.jsx";
import SportsNest from "./privacy/SportsNest.jsx";
import AiUtilityHub from "./privacy/AiUtilityHub.jsx";
import AiUtilityHubTerms from "./terms/AiUtilityHub.jsx";
import AiUtilityHubDelete from "./delete/AiUtilityHub.jsx";
import AccountDelete from "./delete/Triphop.jsx";
import CalcMaster from "./privacy/CalcMaster.jsx";
import CalcMasterDelete from "./delete/CalcMaster.jsx";
import Qapture from "./privacy/Qapture.jsx";
import QaptureDelete from "./delete/Qapture.jsx";
import Expentry from "./privacy/Expentry.jsx";
import ExpentryDelete from "./delete/Expentry.jsx";
// import TripHop from "./privacy/TripHop";
// import Nimora from "./privacy/Nimora";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Add all your privacy pages here */}
        <Route path="/privacy/kenny-fish" element={<KennyFish />} />
        <Route path="/privacy/rayhan-car" element={<Rayhancar />} />
        <Route path="/privacy/triphop" element={<Triphop />} />
        <Route path="/privacy/sportsnest" element={<SportsNest />} />
        <Route path="/privacy/ai-utility-hub" element={<AiUtilityHub />} />
        <Route path="/privacy/notecalc-pro" element={<CalcMaster />} />
        <Route path="/privacy/notecalc" element={<CalcMaster />} />
        <Route path="/privacy/calcmaster" element={<CalcMaster />} />
        <Route path="/privacy/calc-master" element={<CalcMaster />} />
        <Route path="/privacy/qapture" element={<Qapture />} />
        <Route path="/privacy/scanfi" element={<Qapture />} />
        <Route path="/privacy/expentry" element={<Expentry />} />
        <Route path="/privacy/track-your-expense" element={<Expentry />} />
        <Route path="/privacy/spendwise" element={<Expentry />} />

        {/* Terms pages */}
        <Route path="/terms/ai-utility-hub" element={<AiUtilityHubTerms />} />

        {/* Deletion pages */}
        <Route path="delete-account" element={<DeleteAccount />} />
        <Route path="/rayhan/delete-account" element={<DeleteAccount />} />
        <Route path="/triphop/delete-account" element={<AccountDelete />} />
        <Route path="/ai-utility-hub/delete-account" element={<AiUtilityHubDelete />} />
        <Route path="/notecalc-pro/delete-account" element={<CalcMasterDelete />} />
        <Route path="/notecalc/delete-account" element={<CalcMasterDelete />} />
        <Route path="/calcmaster/delete-account" element={<CalcMasterDelete />} />
        <Route path="/calcmaster/data-deletion" element={<CalcMasterDelete />} />
        <Route path="/qapture/delete-account" element={<QaptureDelete />} />
        <Route path="/scanfi/delete-account" element={<QaptureDelete />} />
        <Route path="/qapture/data-deletion" element={<QaptureDelete />} />
        <Route path="/scanfi/data-deletion" element={<QaptureDelete />} />
        <Route path="/expentry/delete-account" element={<ExpentryDelete />} />
        <Route path="/expentry/data-deletion" element={<ExpentryDelete />} />
        <Route path="/track-your-expense/delete-account" element={<ExpentryDelete />} />
        <Route path="/spendwise/delete-account" element={<ExpentryDelete />} />
        {/* <Route path="/privacy/triphop" element={<TripHop />} />
        <Route path="/privacy/nimora" element={<Nimora />} /> */}

        {/* Home */}
        <Route path="/" element={<h1>Privacy Policy Manager</h1>} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
